import {z} from 'zod';
export const AccountCreditBalanceSchema = z.discriminatedUnion('status', [
  z.object({status: z.literal('not-funded')}).strict(),
  z.object({status: z.literal('ready'), currency: z.literal('USD'),
    availableUsd: z.number().finite(), grantedUsd: z.number().finite().positive(),
    usedUsd: z.number().finite().nonnegative(), observedAt: z.iso.datetime()}).strict()
]);
export type AccountCreditBalance = z.infer<typeof AccountCreditBalanceSchema>;
